import { useEffect } from 'react'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_API_KEYS_SERVER } from '@/app/module/user/definitions'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetAuthTokens = () => {
  const dispatch = useAppDispatch()
  const res = esApi.useListUserAuthTokensQuery()

  useEffect(() => {
    if (!res.error) {
      return
    }
    dispatch(
      createNotification({
        'get-api-keys-error': {
          type: 'error',
          message: ERROR_GET_API_KEYS_SERVER,
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
